import {useEffect, useState} from "react";
import withUser from "../../../../Containers/withUser";
import axios from "axios";
import {buildAPIUrl} from "../../../../urls";
import {toastError, toastSuccess} from "../../../../helpers/toaster";
import {serializeError} from "eth-rpc-errors";

import {networks} from "../wc";

import {
    useAppKit,
    useAppKitAccount,
    useAppKitNetworkCore,
    useAppKitProvider,
    useAppKitEvents
} from "@reown/appkit/react";

import {BrowserProvider, JsonRpcSigner} from "ethers";
import {Wallet} from "lucide-react";
import Popup from "../../Popup";
import {getCookie, setCookie} from "../../../../helpers/cookies";
import {useSearchParams} from "react-router-dom";
import TagManager from "react-gtm-module";

const getNonce = async (account) => {
    const response = await axios.post(buildAPIUrl("/nonce/client"), {
        wallet: account,
    });

    if (response) {
        return response.data;
    } else {
        toastError('Failed to get nonce')
    }

    return "";
};

export const authenticateWallet = async (address, setIsLoading, walletProvider, chainId, setAuthData, refCode) => {
    try {
        setIsLoading(true);

        const {temp_token, message} = await getNonce(address);

        if (!temp_token) {
            // await disconnectWallet();
            return;
        }

        const provider = new BrowserProvider(walletProvider, chainId);
        const signer = new JsonRpcSigner(provider, address);
        const sig = await signer?.signMessage(message);

        axios.defaults.withCredentials = true;
        setCookie('access_token', temp_token, {})
        const verifyResponse = await axios.post(buildAPIUrl("/verify/client"), {
            wallet: address,
            signature: sig,
            ref_code: refCode || '',
            tag: getCookie('btag') || '',
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Front-Host': 'client'
            }
        });

        if (verifyResponse.data && verifyResponse.data.access_token) {
            setAuthData(verifyResponse.data)

            // if (verifyResponse.data.is_sign_up) {
                TagManager.dataLayer({
                    dataLayer: {
                        event: "wallet"
                    }
                });
                TagManager.dataLayer({
                    dataLayer: {
                        event: "Lead"
                    }
                });
            // }
        }
    } catch (e) {
        const serializedError = serializeError(e);
        toastError(serializedError?.data?.originalError?.error?.message || serializedError?.data?.originalError?.shortMessage || 'Something went wrong')
    } finally {
        setIsLoading(false);
    }
};

const ConnectWallet = (props) => {

    const {setAuthData, authorized, user, deleteAuthData} = props
    const events = useAppKitEvents()
    const [isLoading, setIsLoading] = useState(false);

    const {isConnected, address} = useAppKitAccount();
    const {walletProvider} = useAppKitProvider('eip155')
    const {chainId} = useAppKitNetworkCore();
    const {open} = useAppKit()
    const [searchParams, setSearchParams] = useSearchParams()
    const refCode = searchParams.get('ref')
    const [isClickSignIn, setIsClickSignIn] = useState(false)

    const handleClear = () => {
        window.localStorage.clear()
        deleteAuthData()
        window.location.reload()
    }

    const makeAddress = (address) => {
        if (address) {
            const prefix = address.slice(0, 4);
            const suffix = address.slice(-4);

            return `${prefix}...${suffix}`;
        } else {
            return ''
        }
    }

    useEffect(() => {
        console.log(events.data.event)

        switch (events.data.event) {
            case 'SELECT_WALLET':
                setIsLoading(true)
                break;
            case 'MODAL_CLOSE':
                if (localStorage.getItem('@appkit/connection_status') === 'disconnected' && getCookie('access_token')) {
                    deleteAuthData();
                }
                break;
            case 'CONNECT_SUCCESS':
                !authorized && authenticateWallet(address, setIsLoading, walletProvider, chainId, setAuthData, refCode).then(data => {
                }).catch(err => console.log('err', err));
                break;
            case 'DISCONNECT_SUCCESS':
                deleteAuthData();
                break;
            case 'SWITCH_NETWORK':

                const net = networks.find(el => el.id === chainId)

                toastSuccess(`Network Switched to ${net.name}`)

                break;
            default:
                console.log('')
        }
    }, [events]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (walletProvider) {
            walletProvider?.on("accountsChanged", (accounts) => {
                console.log('ACCOUNTS CHANGED');
                if (localStorage.getItem('@appkit/connection_status') === 'connected' && getCookie('access_token')) {
                    deleteAuthData();
                }
            });

            walletProvider?.on("disconnect", (accounts) => {
                console.log('ACCOUNTS DISCONNECTED');
                if (getCookie('access_token')) {
                    deleteAuthData();
                }
            });
        }

    }, [walletProvider]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!authorized && searchParams.get('modal') === 'open') {
            open()
            searchParams.delete('modal')
            setSearchParams(searchParams)
        } else {
            if (searchParams.get('modal') === 'open') {
                searchParams.delete('modal')
                setSearchParams(searchParams)
            }
        }
    }, [searchParams, isConnected]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (authorized) {
            setIsClickSignIn(false)
        }
    }, [authorized]);

    return (
        <div className="wallet">
            {!authorized && isConnected && isLoading ? <Popup
                onClose={() => {
                    setIsLoading(false)
                }}
                title={'Sign Message'}
            >
                <p className={'text_center'}>Please sign the message in your wallet to complete the authentication
                    process.</p>
                {(window.innerWidth < 769 || localStorage.getItem('@appkit/eip155:connected_connector_id') === 'walletConnect') &&
                    <button style={{margin: '0 auto'}} onClick={() => {
                        setIsClickSignIn(true)
                        authenticateWallet(address, setIsLoading, walletProvider, chainId, setAuthData, refCode).then(data => {
                        }).catch(err => console.log('err', err))
                    }}> <span
                        className={'address'}>Sign In</span>
                        {isClickSignIn &&
                            <svg className={'spinner_svg'} width="24" height="24" viewBox="0 0 24 24"
                                 xmlns="http://www.w3.org/2000/svg" fill={'#fff'}>
                                <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                      opacity=".25"/>
                                <path
                                    d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                                    className="spinner_ajPY"/>
                            </svg>}
                    </button>}
                <p className={'clear_caches_cta'}>Have problem with connection? Try to <span
                    onClick={handleClear}
                >clear cache</span>.</p>
            </Popup> : null}


            {authorized && (
                <>
                    <button className={'connected'} onClick={() => open()}><Wallet width={18}/><span
                        className={'address'}>{makeAddress(user.wallet || '')}</span></button>
                </>
            )}
            {!authorized && !isConnected && (
                <>
                    <button onClick={() => open()}><span
                        className={'address'}>Connect Wallet</span></button>
                </>
            )}
            {isConnected && !authorized && (
                <>
                    <button disabled={isLoading} onClick={() => {
                        authenticateWallet(address, setIsLoading, walletProvider, chainId, setAuthData, refCode).then(data => {
                        }).catch(err => console.log('err', err))
                    }}> <span
                        className={'address'}>Sign In</span> {isLoading &&
                        <svg className={'spinner_svg'} width="24" height="24" viewBox="0 0 24 24"
                             xmlns="http://www.w3.org/2000/svg" fill={'#fff'}>
                            <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                  opacity=".25"/>
                            <path
                                d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
                                className="spinner_ajPY"/>
                        </svg>}
                    </button>
                </>
            )}
        </div>
    );
}

export default withUser(ConnectWallet)